import { render, staticRenderFns } from "./ReporteSPPage.vue?vue&type=template&id=185de768"
import script from "./ReporteSPPage.js?vue&type=script&lang=js&external"
export * from "./ReporteSPPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports